module.exports = __webpack_public_path__ + "img/form-t-1.dc6acd1a.svg";